

export const firstCamel = (value:string) => value.charAt(0).toUpperCase() + value.slice(1);

export const pluralize = (count: number, singular: string, plural: string) => {
    return count === 1 ? singular : plural
  }